import {
  ROUTES
} from 'common/const.js'

// 懒加载方式加载路由
const Index = () => import('views/home')

const Entity = () => import('views/virtualcar')

const User = () => import('views/cartype')

const System = () => import('views/statistics')

const Layout = () => import('components/content/layout')

const Remote = () => import('views/remote')

// 所有的页面，用于生成路由
const asyncRoutes = {
  [ROUTES.index]: {
    path: ROUTES.index,
    name: 'index',
    component: Index
  },
  [ROUTES.entity]: {
    path: ROUTES.entity,
    name: 'entity',
    component: Entity
  },

  [ROUTES.user]: {
    path: ROUTES.user,
    name: 'user',
    component: User
  },

  [ROUTES.sys]: {
    path: ROUTES.sys,
    name: 'sys',
    component: System
  },

  [ROUTES.remote]: {
    path: ROUTES.remote,
    name: 'remote',
    component: Remote
  },
  // Layout为可复用组件，需要返回对象，否则会造成多个路由重复
  [ROUTES.layout]() {
    return Layout
  }
}

export default asyncRoutes
